import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { Select, Tooltip } from 'antd';
import block from './block.js';
const blocks = {};
const { Option } = Select;

function anyAscii(string) {
    // 中文直接返回
    if (/.*[\u4e00-\u9fa5]+.*$/.test(string)) {
        return string;
    }
    let result = '';
    for (const c of string) {
        const codePoint = c.codePointAt(0);
        if (codePoint <= 0x7f) {
            result += c;
            continue;
        }
        const blockNum = codePoint >>> 8;
        const lo = codePoint & 0xff;
        let b = blocks[blockNum];
        if (b === undefined) {
            blocks[blockNum] = b = block(blockNum).split("\t");
        }
        if (b.length > lo) {
            result += b[lo];
        }
    }
    return result;
}

function normalizeSearchText(value) {
    return anyAscii(value == undefined ? '' : value.toString()).toLowerCase();
}

function getSelectorKeyword(option) {
    if (!option) {
        return '';
    }
    return option.keyword || option.searchText || option.label || option.name || '';
}

function getMatchRank(keyword, searchText) {
    if (keyword.indexOf(searchText) === 0) {
        return 0;
    }
    return keyword.indexOf(searchText) >= 0 ? 1 : 2;
}

function sortByPrefixMatch(searchInput, optionA, optionB) {
    const searchText = normalizeSearchText(searchInput);
    if (!searchText) {
        return 0;
    }
    const keywordA = normalizeSearchText(getSelectorKeyword(optionA));
    const keywordB = normalizeSearchText(getSelectorKeyword(optionB));
    const rankA = getMatchRank(keywordA, searchText);
    const rankB = getMatchRank(keywordB, searchText);
    if (rankA !== rankB) {
        return rankA - rankB;
    }
    const indexA = keywordA.indexOf(searchText);
    const indexB = keywordB.indexOf(searchText);
    if (indexA !== indexB) {
        return indexA - indexB;
    }
    return keywordA.localeCompare(keywordB);
}

function filterKeywordOption(input, option) {
    return getSelectorKeyword(option) ? normalizeSearchText(getSelectorKeyword(option)).indexOf(normalizeSearchText(input)) >= 0 : false;
}

function sortSelectOptionByPrefixMatch(optionA, optionB, info) {
    return sortByPrefixMatch(info ? info.searchValue : '', optionA, optionB);
}

class Selector extends Component {
    render() {
        const { placeholder, mode, selectLock, name, defaultValue, selectorValues, changeSelector, selectedValue, warning, allowClear, onClear, value, size, title, style } = this.props;
        const shouldSortPrefixMatches = name == 'Brands';
        let v = selectedValue;
        if (v == 0 || v == undefined) {
            if (typeof (v) != 'object') {
                v = '0';
            }
        } else {
            if (typeof (v) != 'object') {
                v = v.toString();
            }
        }

        return (
            <FormGroup controlId={'formControlsSelect' + name} bsSize='small' className={warning} style={style}>
                <Tooltip title={title ? title : ''} arrow={false} placement="left" mouseEnterDelay={0} mouseLeaveDelay={0}>
                {value ?
                    <Select
                        size={size ? size : 'middle'}
                        mode={mode ? mode : null}
                        allowClear={allowClear ? true : false}
                        showSearch
                        status={warning ? 'error' : null}
                        style={{ width: "100%", minWidth: "150px" }}
                        componentClass="select"
                        placeholder={placeholder ? placeholder : 'select'}
                        optionFilterProp="children"
                        onChange={changeSelector}
                        onClear={onClear ? onClear : () => { }}
                        key={v}
                        defaultValue={v}
                        value={value}
                        filterOption={filterKeywordOption}
                        filterSort={shouldSortPrefixMatches ? sortSelectOptionByPrefixMatch : undefined}
                    >
                        {typeof (defaultValue) == 'object' ? null : <Option keyword={defaultValue} searchText={defaultValue} label={defaultValue} value="0">{defaultValue}</Option>}
                        {
                            (selectorValues) ? selectorValues.map(option => {
                                const optionText = option.searchText || option.label || option.name;
                                const optionLabel = option.label || option.name;
                                return <Option keyword={optionText} searchText={optionText} label={optionLabel} value={option.id.toString()} key={option.id} disabled={selectLock ? false : (option.lock ? true : false)}>{optionLabel} {option.lock ? '🔒' : ''}</Option>
                            }) : null
                        }
                    </Select>
                    :
                    <Select
                        size={size ? size : 'middle'}
                        mode={mode ? mode : null}
                        allowClear={allowClear ? true : false}
                        showSearch
                        status={warning ? 'error' : null}
                        style={{ width: "100%", minWidth: "150px" }}
                        componentClass="select"
                        placeholder={placeholder ? placeholder : 'select'}
                        optionFilterProp="children"
                        onChange={changeSelector}
                        onClear={onClear ? onClear : () => { }}
                        key={v}
                        defaultValue={v}
                        filterOption={filterKeywordOption}
                        filterSort={shouldSortPrefixMatches ? sortSelectOptionByPrefixMatch : undefined}
                    >
                        {typeof (defaultValue) == 'object' ? null : <Option keyword={defaultValue} searchText={defaultValue} label={defaultValue} value="0">{defaultValue}</Option>}
                        {
                            (selectorValues) ? selectorValues.map(option => {
                                const optionText = option.searchText || option.label || option.name;
                                const optionLabel = option.label || option.name;
                                return (
                                    <Option keyword={optionText} searchText={optionText} label={optionLabel} value={option.id.toString()} key={option.id} disabled={selectLock ? false : (option.lock ? true : false)}>
                                        <Tooltip arrow={false} title={(name == 'ztn_id') ? option.remark : ''} placement="right" mouseEnterDelay={0} mouseLeaveDelay={0}>
                                            {optionLabel} {option.lock ? '🔒' : ''}
                                            {(name == 'ztn_id' && option.problem) ? '🔒' : ''}
                                        </Tooltip>
                                    </Option>
                                )
                            }) : null
                        }
                    </Select>
                }
                </Tooltip>
            </FormGroup>
        );
    }
}

export default Selector;
